<template>
  <div class="con-wrap">
    <el-aside width="280px">
      <el-row class="left-title" :gutter="20">
        <el-col class="font-bold" :span="16">
          <div class="grid-content bg-purple">电子围栏列表</div>
        </el-col>
        <el-col :span="8">
          <span class="edit-box" style="float:right">
            <span
              v-if="hasPerm('geo:fence:add')"
              class="iconfont icon-add"
              @click="addFence"
              style="margin-right:5px"
            ></span>
            <span
              v-if="hasPerm('geo:fence:update')"
              class="iconfont icon-edit"
              @click="editFence"
              style="margin-right:5px"
            ></span>
            <span
              v-if="hasPerm('geo:fence:update')"
              class="iconfont icon-delete"
              @click="deletFence"
            ></span>
          </span>
        </el-col>
      </el-row>
      <!-- 添加回车搜索 -->
      <div class="fence-search">
        <el-input
          @blur="getFenceList"
          @keyup.enter.native="getFenceList"
          placeholder="请输入围栏名称"
          prefix-icon="el-icon-search"
          v-model="fenceName"
        ></el-input>
      </div>
      <div style="margin-top: 16px;height: calc(100% - 100px)">
        <ul
          class="fence-list"
          v-infinite-scroll="load"
          infinite-scroll-disabled="scroll"
          infinite-scroll-distance="2"
          infinite-scroll-immediate-check="false"
        >
          <li
            v-for="item in pageFenceList"
            class="is-show fence-list-con"
            :class="{ active: flag == item.gfid }"
            :key="item.gfid"
            @click="getFenceInfo(item)"
          >
            <span class="postName text-overflow" :title="item.name"
              ><i :class="testColor[item.monitorStatus]"></i
              >{{ item.name }}</span
            >
            <span v-if="item.warningCount != 0">
              <span class="iconfont icon-alarm color-red"></span>
              <span style="font-size:14px;padding-left:6px">{{
                item.warningCount
              }}</span>
            </span>
          </li>
        </ul>
      </div>
    </el-aside>

    <el-container class="map-wrap">
      <div
        class="map-box"
        v-loading="loading"
        element-loading-text="拼命加载中"
      >
        <draw-fence
          v-if="carData"
          :mapData="mapData"
          :carData="carData"
          :centerLnglat="centerLnglat"
          :alarmLnglat="alarmLnglat"
        ></draw-fence>
      </div>
      <div class="alarm-wrap">
        <div v-if="alarmFlag" class="alarm-title">
          <span>【{{ alarmFenceName }}】今日告警</span>
          <span class="query-recode" @click="historyRecode"
            >查看历史记录<span
              class="iconfont icon-drop-down query-icons"
            ></span
          ></span>
        </div>
        <div v-else class="alarm-title">
          <span>【{{ alarmFenceName }}】历史记录</span>
          <span class="query-recode" @click="todayAlarm"
            >返回今日告警<span class="iconfont icon-drop-down back-icons"></span
          ></span>
        </div>
        <div class="alarm-box">
          <el-table
            v-infinite-scroll="recordLoad"
            infinite-scroll-disabled="recordScroll"
            infinite-scroll-distance="10"
            infinite-scroll-immediate-check="false"
            ref="multipleTable"
            :data="alarmData"
            tooltip-effect="dark"
            style="width: 100%"
            size="mini"
            height="240px"
            v-loading="tableLoading"
          >
            <el-table-column
              prop="addTime"
              label="时间"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column prop="plateNum" label="车牌号"></el-table-column>
            <el-table-column
              prop="personnelName"
              label="车主"
            ></el-table-column>
            <el-table-column
              prop="personnelPhone"
              label="联系电话"
              width="160"
            ></el-table-column>
            <el-table-column prop="monitorType" label="类型">
              <template slot-scope="scope">
                <span v-if="scope.row.monitorType == 1">驶入监控</span>
                <span v-else-if="scope.row.monitorType == 2">驶出监控</span>
                <span v-else-if="scope.row.monitorType == 3">驶入驶出监控</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="warnType"
              label="内容"
              width="160"
            ></el-table-column>
            <el-table-column prop="endTime" label="地点"></el-table-column>
            <el-table-column label="操作" width="150" fixed="right">
              <template slot-scope="scope">
                <span
                  class="iconfont icon-position"
                  size="mini"
                  type="text"
                  v-if="hasPerm('order:manage:info')"
                  @click.stop="getAlarmAddr(scope.row)"
                ></span>
                <span
                  class="iconfont icon-car-fill"
                  size="mini"
                  type="text"
                  v-if="hasPerm('order:manage:info')"
                  @click.stop="getOrderInfo(scope.row)"
                ></span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
import DrawFence from "./components/DrawFence.vue"
export default {
  components: {
    DrawFence,
  },
  data() {
    return {
      fenceName: "",
      fenceList: [],
      pageFenceList: [],
      flag: -1,
      nowPage: 1,
      scroll: false,
      testColor: ["", "dot green", "dot red"],
      alarmFenceName: "",
      alarmFlag: true,
      alarmData: [],
      recordPage: 1,
      recordLimit: 100,
      tableLoading: false,
      recordScroll: true,
      mapData: {},
      carData: [],
      loading: false,
      centerLnglat: [],
      timer: null,
      gfid: "",
      alarmLnglat: [],
    }
  },
  created() {
    this.getFenceList()
  },

  watch: {
    fenceList(val) {
      if (val[0]) {
        this.$nextTick(() => {
          document.querySelector(".fence-list-con").click()
        })
      }
    },
  },
  methods: {
    deletFence() {
      this.$confirm("确认删除电子围栏？")
        .then(() => {
          this.confirmDeletFence()
        })
        .catch(() => {})
    },
    // 删除电子围栏
    async confirmDeletFence() {
      let _this = this
      let { data: res } = await _this.$axios.delete(
        `/api/geo/fence/${this.gfid}`
      )
      if (res.code == 1) {
        _this.$message.success("删除成功")
        _this.getFenceList()
      } else {
        _this.$message.warning(res.msg)
      }
    },
    async getFenceList() {
      this.scroll = false
      this.nowPage = 1
      let _this = this
      let parm = {
        name: _this.fenceName,
      }
      let { data: res } = await _this.$axios.get("/api/geo/fence/list", {
        params: parm,
      })
      if (res.code == 1) {
        if (res.data.length >= 50) {
          this.scroll = false
          _this.fenceList = res.data
          _this.pageFenceList = _this.fenceList.slice(0, 50)
        } else {
          this.scroll = true
          _this.fenceList = res.data
          _this.pageFenceList = res.data
        }
      } else {
        _this.$message.warning(res.msg)
      }
    },
    addFence() {
      sessionStorage.setItem("gfid", "")
      this.$router.push("/AddFence")
    },
    editFence() {
      sessionStorage.setItem("gfid", this.gfid)
      this.$router.push("/AddFence")
    },
    load() {
      if (this.fenceList.length == 0) {
        return
      }
      this.pageFenceList = this.pageFenceList.concat(
        this.fenceList.slice(this.nowPage * 50, (this.nowPage + 1) * 50)
      )
      this.nowPage++
      this.scroll = this.fenceList.length >= this.nowPage * 50 ? false : true
    },
    getFenceInfo(data) {
      this.flag = data.gfid
      this.gfid = data.gfid
      this.alarmFenceName = data.name
      this.todayAlarm()
      //清理历史告警记录数据
      this.alarmData = []
      this.recordScroll = true
      this.recordPage = 1
      //绘制围栏及车辆数据获取
      this.getFenceData()
    },
    async historyRecode() {
      if (this.recordPage == 1) {
        this.alarmData = []
      }
      this.alarmFlag = false
      let _this = this
      _this.tableLoading = true
      let obj = {
        gfid: _this.flag,
        page: _this.recordPage,
        limit: _this.recordLimit,
      }
      let { data: res } = await _this.$axios.get(
        "/api/geo/fence/waring/history",
        {
          params: obj,
        }
      )
      if (res.code == 1) {
        _this.tableLoading = false
        _this.recordScroll = false
        _this.alarmData = _this.alarmData.concat(res.data.list)
        if (res.data.totalPage == _this.recordPage) {
          _this.recordScroll = true
        }
        _this.recordPage = res.data.currPage + 1
      } else {
        _this.tableLoading = false
        _this.$message.warning(res.msg)
      }
    },
    async todayAlarm() {
      //清理历史告警记录数据
      this.alarmData = []
      this.recordScroll = true
      this.recordPage = 1
      this.alarmFlag = true
      let _this = this
      _this.tableLoading = true
      let obj = {
        gfid: _this.flag,
      }
      let { data: res } = await _this.$axios.get("/api/geo/fence/waring", {
        params: obj,
      })
      if (res.code == 1) {
        _this.tableLoading = false
        _this.alarmData = res.data
      } else {
        _this.tableLoading = false
        _this.$message.warning(res.msg)
      }
    },
    //历史告警滚动加载触发函数
    recordLoad() {
      if (!this.alarmFlag) {
        this.historyRecode()
      }
    },
    getOrderInfo(data) {
      this.centerLnglat = []
      let oldData = this.carData
      for (let i = 0; i < oldData.length; i++) {
        if (oldData[i].vin == data.vin) {
          this.centerLnglat = oldData[i].lnglat
          return
        }
      }
    },
    getAlarmAddr(data) {
      let arr = []
      if (data.longitude != 0.0 && data.latitude != 0.0) {
        arr.push(data.longitude)
        arr.push(data.latitude)
        this.alarmLnglat = arr
      } else {
        this.$message.warning("该记录无定位点信息")
      }
    },
    async getFenceData() {
      let _this = this
      _this.loading = true
      let obj = {
        gfid: _this.flag,
      }
      let { data: res } = await _this.$axios.get("/api/geo/fence/info", {
        params: obj,
      })
      if (res.code == 1) {
        _this.loading = false
        _this.mapData = res.data
        _this.addCar()
        if (_this.timer) {
          clearInterval(_this.timer)
        }
        if (this.$route.path === "/Geofencing") {
          _this.timer = setInterval(function() {
            _this.addCar()
          }, 15000)
        }
      } else {
        _this.loading = false
        _this.$message.warning(res.msg)
      }
    },

    async addCar() {
      let _this = this
      //_this.loading = true
      let obj = {
        gfid: _this.flag,
      }
      let { data: res } = await _this.$axios.get("/api/geo/fence/vehicle/gps", {
        params: obj,
      })
      if (res.code == 1) {
        //_this.loading = false
        _this.carData = res.data
      } else {
        //_this.loading = false
        _this.$message.warning(res.msg)
      }
    },
  },
  beforeDestroy() {
    let _this = this
    _this.$once("hook:beforeDestroy", () => {
      clearInterval(_this.timer)
    })
  },
}
</script>

<style lang="scss" scoped>
.con-wrap {
  display: flex;
  flex-direction: row;
}
.left-title {
  display: flex;
  justify-content: space-between;
  height: 40px;
  margin-bottom: 10px !important;
  padding: 10px 20px;
  border-bottom: 1px solid #ccc;
  font-size: 16px;
  color: #333;
  .font-bold {
    font-weight: bold;
  }
  .edit-box {
    cursor: pointer;
  }
}
.con-wrap .el-container {
  height: 100%;
  overflow: auto;
  background-color: #fff;
}
.fence-search {
  padding: 0 20px;
  & /deep/ {
    .el-input__inner {
      height: 32px;
    }
    .el-input__icon {
      line-height: 34px;
    }
  }
}
.fence-list {
  height: 100%;
  position: relative;
  cursor: default;
  background: #fff;
  color: #606266;
  overflow: auto;
  li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 24px;
    line-height: 24px;
    padding: 0 20px;
    font-size: 14px;
    color: #333;
    cursor: pointer;
    .dot {
      display: inline-block;
      width: 12px;
      height: 12px;
      margin-right: 8px;
      border-radius: 50%;
    }
    .green {
      background-color: #00ea9a;
    }
    .red {
      background-color: #e50026;
    }
    .postName {
      display: inline-block;
      width: 190px;
    }
  }
  .active {
    background: #ddf0fe !important;
  }
  .color-red {
    font-size: 16px;
    color: #e50026;
  }
}
.map-wrap {
  position: relative;
  width: 100%;
  flex-direction: column;
  background-color: #f8f8f8;
}
.map-box {
  width: 100%;
  height: calc(100% - 240px);
  box-sizing: border-box;
}
.alarm-wrap {
  width: 100%;
  height: 273px;
  position: absolute;
  bottom: 0;
  box-sizing: border-box;
  z-index: 2;
  .alarm-title {
    display: flex;
    justify-content: space-between;
    // width:400px;
    width: fit-content;
    padding-left: 10px;
    line-height: 32px;
    font-size: 16px;
    font-weight: bold;
    color: #333;
    background-color: #fff;
  }
  .query-recode {
    padding-left: 20px;
    padding-right: 10px;
    color: #0094ff;
    font-size: 14px;
    font-weight: normal;
    cursor: pointer;
    span {
      margin-left: 4px;
      font-size: 12px;
    }
  }
  .query-icons {
    display: inline-block;
    transform: rotate(-90deg);
    -o-transform: rotate(-90deg);
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
  }
  .back-icons {
    display: inline-block;
    transform: rotate(90deg);
    -o-transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
  }
}
.alarm-box /deep/ {
  .el-table--mini td,
  .el-table--mini th {
    padding: 4px 0;
  }
  .el-table--mini tr > td:first-child,
  .el-table--mini tr > th:first-child {
    padding-left: 20px;
  }
  .icon-position {
    color: #ff0600;
    cursor: pointer;
  }
  .icon-car-fill {
    color: #ff9000;
    cursor: pointer;
  }
}
</style>
